import { render, staticRenderFns } from "./UserInsuranceData.vue?vue&type=template&id=7afc43e2&scoped=true"
import script from "./UserInsuranceData.vue?vue&type=script&lang=js"
export * from "./UserInsuranceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc43e2",
  null
  
)

export default component.exports